export default "__VITE_ASSET__CQvmo9Nc__"